import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// local components
import DiscountDetails from './DiscountDetails'
import SelectDays from './SelectDays'
import ProductInfoLink from './ProductInfoLink'
import DayPassProductInfo from './DayPassProductInfo'

// helpers
import { centsToDollars } from 'lib/helpers/money'
import { cartProductTotal } from 'lib/cart/decorators/cartProduct'

const VolumeDiscountProduct = props => {
  const {
    product,
    camper,
    session,
    camperSession,
    dayPassPriceCents,
    volumeDiscountPriceCents,
    plan,
    cartProduct,
    account
  } = props

  const { accountDiscount, selectedType, days } = cartProduct
  const { discountCents, discountCategory } = accountDiscount || {}
  const { volumeDiscountDescription, variablePriceCents, volumeDiscountCents } =
    product || {}
  const basePriceCents = variablePriceCents - volumeDiscountCents

  const modalId = `product-info-${camper.id}-${session.id}-volume-discount`

  // display the cart product total if upgrading to volume discount
  const total = cartProductTotal(cartProduct, account)
  const displayTotal =
    selectedType === 'volume-discount' &&
    days > 0 &&
    total / days !== volumeDiscountPriceCents

  const displayPrice = displayTotal
    ? centsToDollars(total) // upgrade price
    : `${centsToDollars(volumeDiscountPriceCents)}/day` // day price

  const modalTitle = `${volumeDiscountDescription} - ${displayPrice}`

  return (
    <Box display='flex' my={1}>
      <Box flexShrink={0} alignItems='center'>
        <SelectDays
          camper={camper}
          plan={plan}
          session={session}
          camperSession={camperSession}
          product={product}
          cartProduct={cartProduct}
          productType={'volume-discount'}
        />
      </Box>
      <Box display='flex' alignItems='center'>
        <Typography ml={1} component='span' variant='body1'>
          {volumeDiscountDescription} – {displayPrice}
          {discountCents > 0 && !displayTotal && (
            <DiscountDetails>
              ({centsToDollars(basePriceCents)}/day -{' '}
              {centsToDollars(discountCents)} {discountCategory} discount)
            </DiscountDetails>
          )}
        </Typography>

        {/* modal */}
        <ProductInfoLink modalId={modalId} />
        <DayPassProductInfo
          modalId={modalId}
          modalTitle={modalTitle}
          product={product}
          session={session}
          dayPassPriceCents={dayPassPriceCents}
          volumeDiscountPriceCents={volumeDiscountPriceCents}
          addDaysPriceCents={volumeDiscountPriceCents}
        />
      </Box>
    </Box>
  )
}

export default VolumeDiscountProduct
